import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BllTableComponent } from './table.component';
import { BllTableColumnDirective } from './table-row.directive';
import { BllIconModule } from '../icon';

@NgModule({
  declarations: [BllTableComponent, BllTableColumnDirective],
  exports: [BllTableComponent, BllTableColumnDirective],
  imports: [CommonModule, BllIconModule],
})
export class BllTableModule {}
